import { PrismicRichText } from '@prismicio/react';
import { ReactElement } from 'react';

import { IProps } from './types';
import * as S from './styles';

export function SliceOurPartners({
  slice: { primary, fields },
}: IProps): ReactElement {
  return (
    <S.Wrapper className="slice-item slice-our-partners">
      {primary && primary?.our_partners_title[0].text && (
        <S.Title className="slice-our-partners__title">
          <PrismicRichText field={primary.our_partners_title} />
        </S.Title>
      )}
      {fields && (
        <S.List className="slice-our-partners__icons-list">
          {fields.map(({ logo_image }, i) => (
            <S.Item
              className="slice-our-partners__icon"
              key={`slice-our-partners__icon_${i}`}
            >
              <img src={logo_image.url} alt="" />
            </S.Item>
          ))}
        </S.List>
      )}
    </S.Wrapper>
  );
}

SliceOurPartners.componentName = 'our_partners';
